import { ProfileCardRedesign } from './ProfileCardRedesign';

export function ProfileCardWrapper() {
	return (
		<div className="mb-16 px-4 md:px-0">
			<ProfileCardRedesign />
		</div>
	);
}
